import ComparisonImage from "../../../../content/articles/2015-06-29-weighted-quick-union-find-algorithm-in-ruby/quick-union-comparison.png";
import WeightedImage from "../../../../content/articles/2015-06-29-weighted-quick-union-find-algorithm-in-ruby/weighted-quick-union.png";
import React from 'react';
export default {
  ComparisonImage,
  WeightedImage,
  React
};